
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/dummy.js';
            vueApps['app/dummy.js'] = App0;
        

            import App1 from './app/navbar.js';
            vueApps['app/navbar.js'] = App1;
        

            import App2 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App2;
        

            import App3 from './hangtag.js';
            vueApps['hangtag.js'] = App3;
        

            import App4 from './app/search.js';
            vueApps['app/search.js'] = App4;
        

            import App5 from './app/unit.js';
            vueApps['app/unit.js'] = App5;
        

            import App6 from './app/facilityunits.js';
            vueApps['app/facilityunits.js'] = App6;
        

            import App7 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App7;
        

            import App8 from './app/region.js';
            vueApps['app/region.js'] = App8;
        

            import App9 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App9;
        

            import App10 from './app/newsletter.js';
            vueApps['app/newsletter.js'] = App10;
        

            import App11 from './app/searchyoga.js';
            vueApps['app/searchyoga.js'] = App11;
        

            import App12 from './app/searchmithund.js';
            vueApps['app/searchmithund.js'] = App12;
        

            import App13 from './app/searchkrakow.js';
            vueApps['app/searchkrakow.js'] = App13;
        

            import App14 from './app/searchfuhlendorf.js';
            vueApps['app/searchfuhlendorf.js'] = App14;
        

            import App15 from './app/searchsauna.js';
            vueApps['app/searchsauna.js'] = App15;
        

            import App16 from './index-action-modal.js';
            vueApps['index-action-modal.js'] = App16;
        

            import App17 from './app/searchostsee.js';
            vueApps['app/searchostsee.js'] = App17;
        

            import App18 from './app/searchmueritz.js';
            vueApps['app/searchmueritz.js'] = App18;
        

            import App19 from './app/searchmitwasserblick.js';
            vueApps['app/searchmitwasserblick.js'] = App19;
        

            import App20 from './app/searchfurfamilien.js';
            vueApps['app/searchfurfamilien.js'] = App20;
        

            import App21 from './app/searchzingst.js';
            vueApps['app/searchzingst.js'] = App21;
        

            import App22 from './app/searchwustrow.js';
            vueApps['app/searchwustrow.js'] = App22;
        

            import App23 from './app/searchmalchow.js';
            vueApps['app/searchmalchow.js'] = App23;
        

            import App24 from './app/searchfischland.js';
            vueApps['app/searchfischland.js'] = App24;
        

        
                import Comp25 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp25);
            

                import Comp26 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp26);
            

                import Comp27 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp27);
            

                import Comp28 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp28);
            

                import Comp29 from './comp/cancellationPolicy.vue';
                Vue.component('cancellationpolicy',Comp29);
            

                import Comp30 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp30);
            

                import Comp31 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp31);
            

                import Comp32 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp32);
            

                import Comp33 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp33);
            

                import Comp34 from './comp/childrenage.vue';
                Vue.component('childrenage',Comp34);
            

                import Comp35 from './comp/Voucher-Unit.vue';
                Vue.component('voffice-voucher-unit',Comp35);
            

                import Comp36 from './comp/seasonprices.vue';
                Vue.component('seasonprices',Comp36);
            

                import Comp37 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp37);
            

                import Comp38 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp38);
            

                import Comp39 from './comp/Voucher-Search.vue';
                Vue.component('voffice-voucher-search',Comp39);
            

                import Comp40 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp40);
            

                import Comp41 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp41);
            

                import Comp42 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp42);
            

                import Comp43 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp43);
            

                import Comp44 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp44);
            

                import Comp45 from './comp/ImgFallback2.vue';
                Vue.component('img-fallback2',Comp45);
            

                import Comp46 from './comp/cutText.js';
                Vue.component('voffice-cut-text',Comp46);
            

                import Comp47 from './videoIframe.vue';
                Vue.component('video-iframe',Comp47);
            

                import Comp48 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp48);
            

                import Comp49 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp49);
            

                import Comp50 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp50);
            

                import Comp51 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp51);
            

                import Comp52 from './offershelp.vue';
                Vue.component('offer-help',Comp52);
            

                import Comp53 from './comp/feedback-carousel.vue';
                Vue.component('feedback-carousel',Comp53);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    